import axios from "axios";
import {route} from "preact-router";
import {responseValidator} from "../../utils";
import {loginMiddleware} from "../../lib/middlewares/login.middleware";

const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? '/api' : "",
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "ngrok-skip-browser-warning": "69420"
    }
});

class RequestInterface {
    async request(
        url,
        method,
        data = undefined,
        config = {},
    ) {
        let response;

        // Dispatches the request
        response = await axiosInstance.request({
            url,
            method,
            data,
            ...config
        });

        // If no content exists, then it redirects to page 404
        if (response.status === 204) {
            return route('not-found', true);
        }

        // Validates whether the response is a valid JSON object or not
        const isResponseValid = responseValidator(response.data);

        // Validates whether the response returned from the server is a valid JSON or not
        if (!isResponseValid) {
            return route('error', true);
        }

        // TODO: all middlewares must come down below,
        //  after the requests have been all validated
        // Login middleware
        // if (url.includes("/v1/login/login")) {
        //     loginMiddleware("", response);
        // }

        return response;
    }

    async get(url, config) {
        return await this.request(url, "get", undefined, config);
    }

    async post(url, data, config) {
        return await this.request(url, "post", data, config);
    }

    async put(url, data, config) {
        return await this.request(url, "put", data, config);
    }

    async delete(url, data, config) {
        return await this.request(url, "delete", data, config);
    }

    async patch(url, data, config) {
        return await this.request(url, "patch", data, config);
    }
}

const api = new RequestInterface();

export default api;
